module.exports = __webpack_public_path__ + "img/wrong-circle.fbd56577.png";